{
  "folders": {
    "actions": {
      "rename": "Rename",
      "move_to": "Move to",
      "create_workspace": "Create Workspace",
      "create_folder": "Create Folder",
      "delete": "Delete"
    },
    "forms": {
      "folder_name": "Folder Name",
      "enter_folder_name": "Enter a folder name",
      "my_folders": "My Folders",
      "move_here": "Move Here",
      "choose_folder": "Choose a folder"
    },
    "confirmations": {
      "delete_folder_title": "Delete folder?",
      "delete_folder_content": "Are you sure you want to delete this folder? You can't undo this action.",
      "move_workspace": "Move Workspace"
    },
    "errors": {
      "unable_to_delete": "Unable to Delete"
    }
  },
  "members": {
    "team": "Team",
    "add_member": "Add Member",
    "add_team_members": "Add Team Members",
    "team_member": "Team Member",
    "who_add_placeholder": "Who do you want to add to this workspace",
    "validation": {
      "select_team_member": "Please select at least one team member"
    },
    "confirmations": {
      "remove_member_title": "Are you sure you want to remove this member?",
      "remove_member_content": "This person will no longer have access to the workspace."
    },
    "aria_labels": {
      "remove_member": "remove member {{email}}"
    }
  },
  "forms": {
    "title": "Title",
    "folder": "Folder",
    "icon": "Icon",
    "color": "Color",
    "firm_wide_access": "Allow Firm Wide Access",
    "read_only": "Read Only",
    "validation": {
      "title_required": "Please enter project title"
    },
    "placeholders": {
      "app_description": "What is your app about?",
      "workspace_description": "How will you collaborate in this Workspace"
    },
    "aria_labels": {
      "project_icon": "project icon {{index}}",
      "select_color": "select {{description}}"
    }
  },
  "actions": {
    "create_app": "Create App",
    "create_workspace": "Create Workspace",
    "update_app": "Update App",
    "update_workspace": "Update Workspace",
    "clone_app": "Clone App",
    "clone_workspace": "Clone Workspace"
  },
  "status": {
    "loading_workspaces": "Loading workspaces",
    "search_no_results": "Cannot find workspace(s) with the title \"{{term}}\"",
    "no_workspaces": "There's no workspace and folder for you, create one now"
  },
  "table": {
    "headers": {
      "name": "Name",
      "owner": "Owner",
      "created_at": "Created At"
    }
  },
  "tooltips": {
    "firm_wide_workspace": "Firm Wide Workspace"
  },
  "app": {
    "create_view_label": "Company View",
    "read_only": "Read-only",
    "no_access_message": "You don't have access to this project. Please ask the person who shared the link with you to add you as a team member.",
    "search_no_results": "Cannot find app(s) with the title \"{{term}}\"",
    "no_apps_message": "There's no app for you, create one now",
    "view_table": "Table",
    "view_grid": "Grid",
    "get_started_message": "To get started, add your first list from the + button above on the left.",
    "unknown_tab_type": "Unknown tab type",
    "table": {
      "app_header": "App",
      "workspace_header": "Workspace",
      "team_members_header": "Team members"
    },
    "team_share": "Team/Share",
    "team": "Team"
  },
  "opportunities": {
    "form": {
      "header": "Opportunity",
      "company_label": "Select Associated Company *",
      "company_placeholder": "Type to search company",
      "status_label": "Status",
      "description_label": "Description",
      "description_placeholder": "Describe your opportunity in one sentence",
      "tags_label": "Tags",
      "proposed_fee_label": "Proposed Fee",
      "date_label": "Opportunity Date",
      "date_placeholder": "date",
      "internal_owner_label": "Internal Owner",
      "internal_owner_placeholder": "Who will be responsible for this opportunity?",
      "team_involved_label": "Team Involved",
      "team_involved_placeholder": "Team involved in this opportunity?",
      "referral_source_label": "Referral Source",
      "referral_source_placeholder": "Who referred this opportunity?"
    },
    "workspace": {
      "link_button": "Link Workspace",
      "link_modal_label": "Workspaces",
      "link_validation": "Please select a workspace",
      "unlink_title": "unlink opportunity from workspace",
      "unlink_confirmation": "Click confirm to unlink the opportunity from workspace",
      "unlink_confirm_title": "Are you sure you want to unlink this opportunity?",
      "actions": {
        "update": "Update",
        "unlink": "Unlink"
      },
      "custom_fields": {
        "section_header": "Workspace Columns"
      }
    },
    "actions": {
      "add_opportunity": "Add Opportunity",
      "add_column": "Add Column"
    }
  },
  "more_actions": {
    "manage_columns": "Manage Columns"
  }
}
